import Http from "../http";
import { RiskAssessment } from "../models/survey";

export default function(http: Http) {
  return {
    getRiskScore(): Promise<RiskAssessment> {
      return http.get("/user/risk_assessment");
    },

    postRiskScore(data: { level: number; description?: string }) {
      return http.post("user/risk_assessment", { data });
    }
  };
}
